import React from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  IconButton,
  styled,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

/*".&MuiTableCell-root": {
  color: "#532A0C",
},*/

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: "#972020",
  // "& .MuiTableCell-root": {
  //   [theme.breakpoints.up("sm")]: {
  //     fontSize: "14px !important",
  //   },
  //   [theme.breakpoints.up("xs")]: {
  //     fontSize: "12px !important",
  //   },
  //   [theme.breakpoints.down("xs")]: {
  //     fontSize: "8px !important",
  //   },
  // },
}));

export const TableOrderSummary = (props) => {
  const { order, taxes, onEdit, onRemove } = props;
  return (
    <TableContainer
      component={Paper}
      elevation={6}
      sx={{ maxHeight: "385px", marginTop: "15px" }} //, backgroundColor: "#121212"
    >
      <Table
        stickyHeader
        aria-label="Order summary table:"
        sx={{
          minWidth: "90%",
          //height: "100%",
          // border: "2px solid",
          tableLayout: "fixed",
          padding: "5px",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                width: "40%",
                color: "#972020",
                fontSize: { xs: "12px", sm: "14px" },
              }}
            >
              Product
            </TableCell>
            <TableCell
              align="center"
              sx={{
                color: "#972020",
                fontSize: { xs: "12px", sm: "14px" },
              }}
            >
              Qty
            </TableCell>
            {/* <TableCell align="center">Price</TableCell> */}
            <TableCell
              align="right"
              sx={{
                color: "#972020",
                fontSize: { xs: "12px", sm: "14px" },
              }}
            >
              Total
            </TableCell>
            {/*onEdit && order?.OrderDetails?.length > 0 ? (
              <TableCell
                align="center"
                sx={{ width: { sm: "40px", xs: "30px" } }}
              ></TableCell>
            ) : null*/}
            {onRemove && order?.OrderDetails?.length > 0 ? (
              <TableCell
                align="center"
                sx={{ width: { sm: "40px", xs: "30px" } }}
              ></TableCell>
            ) : null}
          </TableRow>
        </TableHead>

        <TableBody>
          {order?.OrderDetails?.length > 0
            ? order.OrderDetails.filter((x) => !x.removed).map((row, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell
                      style={{
                        whiteSpace: "pre",
                        whiteSpace: "pre-wrap",
                      }}
                      sx={{
                        fontSize: "12px",
                        fontWeight: "100 !important",
                      }}
                    >
                      {row.fullDescription}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontSize: "12px",
                        fontWeight: "100 !important",
                      }}
                    >
                      {row.quantity}
                    </TableCell>
                    {/* <TableCell align="center">
                      {row.totalUnitPrice.toFixed(2)}
                    </TableCell> */}
                    <TableCell
                      align="right"
                      sx={{
                        fontSize: "12px",
                        fontWeight: "100 !important",
                      }}
                    >
                      {row.subTotal.toFixed(2)}
                    </TableCell>
                    {/*onEdit && order?.OrderDetails?.length > 0 ? (
                      <>
                        <TableCell align="center">
                          <IconButton
                            color="primary"
                            onClick={() =>
                              onEdit(
                                row.productId,
                                true,
                                index,
                                row.id,
                                row.quantity
                              )
                            }
                            sx={{
                              display: {
                                xs: "inline-flex",
                                justifyContent: "center",
                                width: { sm: "20px", xs: "20px" },
                                height: { sm: "20px", xs: "20px" },
                              },
                            }}
                            disabled={row?.status == "removed"}
                          >
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                      </>
                    ) : null*/}
                    {onRemove && order?.OrderDetails?.length > 0 ? (
                      <>
                        <TableCell align="center">
                          <IconButton
                            color="primary"
                            onClick={() => onRemove(index)}
                            sx={{
                              display: {
                                xs: "inline-flex",
                                justifyContent: "center",
                                width: { sm: "20px", xs: "20px" },
                                height: { sm: "20px", xs: "20px" },
                              },
                            }}
                            disabled={row?.status == "removed"}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </>
                    ) : null}
                  </TableRow>
                );
              })
            : null}
          {order?.promoDiscount > 0 ? (
            <TableRow
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell style={{ whiteSpace: "pre" }}>
                {order.promoCode}
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                -{order.promoDiscount.toFixed(2)}
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>

        <TableFooter>
          <TableRow>
            <StyledTableCell colSpan={2}>Subtotal:</StyledTableCell>
            <StyledTableCell align="right">
              {`$${(order.subTotal || 0).toFixed(2)}`}
            </StyledTableCell>
            <StyledTableCell colSpan={1}></StyledTableCell>
            {order?.OrderDetails?.length > 0 ? <TableCell rowSpan={5} /> : null}
          </TableRow>
          {taxes.map((x, index) => {
            return (
              <TableRow>
                <StyledTableCell
                  colSpan={2}
                >{`${x.name} (${x.rate}%): `}</StyledTableCell>
                <StyledTableCell align="right">
                  {`$${(order[`totalTax${index + 1}`] || 0).toFixed(2)}`}
                </StyledTableCell>
                <StyledTableCell colSpan={1}></StyledTableCell>
              </TableRow>
            );
          })}
          {order.serviceCharge > 0 ? (
            <TableRow>
              <StyledTableCell colSpan={2}>Service Charge:</StyledTableCell>
              <StyledTableCell align="right">
                {`$${(order.serviceCharge || 0).toFixed(2)}`}
              </StyledTableCell>
              <StyledTableCell colSpan={1}></StyledTableCell>
            </TableRow>
          ) : null}

          {order.tip > 0 ? (
            <TableRow>
              <StyledTableCell colSpan={2}>Tip:</StyledTableCell>
              <StyledTableCell align="right">
                {`$${(order.tip || 0).toFixed(2)}`}
              </StyledTableCell>
              <StyledTableCell colSpan={1}></StyledTableCell>
            </TableRow>
          ) : null}

          <TableRow>
            <StyledTableCell colSpan={2}>Total:</StyledTableCell>
            <StyledTableCell align="right">
              {`$${(order.orderTotal || 0).toFixed(2)}`}
            </StyledTableCell>
            <StyledTableCell colSpan={1}></StyledTableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};
